import { render } from "./MdCheckbox.vue?vue&type=template&id=4814785b&scoped=true&ts=true"
import script from "./MdCheckbox.vue?vue&type=script&lang=ts"
export * from "./MdCheckbox.vue?vue&type=script&lang=ts"

import "./MdCheckbox.vue?vue&type=style&index=0&id=4814785b&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4814785b"]])

export default __exports__